import { FC } from "react"
import { Card as UTKCard } from "@icanbwell/ui-toolkit"
import Link from "@client-hub/shared/react/components/Link"
import { Box, Typography, Grid, CardContent, styled } from "@mui/material"
import { LinkMeta } from "@client-hub/shared/react/hooks/links"
import { useAnalyticsTrackEvent } from "@client-hub/shared/react/components/AnalyticsProvider"
import { useSelector } from "react-redux"
import { APP_NAME } from "@client-hub/shared/constants/analytics"
import { selectCrsUser } from "@client-hub/store/slices/metadata/selectors"

const SVGWrapper = styled(Box)({
  marginRight: "1rem",
  display: "flex",
  "& svg": {
    height: "4em !important",
    width: "auto !important",
  },
})

const Wrapper = styled(UTKCard)(({ theme }) => ({
  height: "10rem",
  backgroundColor: `${theme.palette.common.primaryBase} !important`,
}))

const Card: FC<LinkMeta> = ({ label, icon, to, href, trackEventAction }) => {
  const { trackEvent } = useAnalyticsTrackEvent()
  const user = useSelector(selectCrsUser)

  const handleCardTrackEvent = () => {
    trackEvent({
      appName: APP_NAME,
      action: trackEventAction,
      properties: user ? { userid: user.member.user.id, email: user.member.user.email } : {},
    })
  }

  return (
    <Grid item xs={4}>
      <Wrapper>
        <Link {...(to ? { to } : { href: href! })} aria-label={label} onClick={handleCardTrackEvent}>
          <CardContent sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
            <SVGWrapper
              sx={{
                "& div[role=img]": {
                  height: "4rem",
                  width: "4rem",
                },
              }}
            >
              {icon}
            </SVGWrapper>
            <Typography
              sx={{
                fontSize: "1.25rem",
                lineHeight: "1.5rem",
                color: "white",
                maxWidth: "6em",
              }}
            >
              {label}
            </Typography>
          </CardContent>
        </Link>
      </Wrapper>
    </Grid>
  )
}
export default Card
